module.exports = __webpack_public_path__ + "static/media/cc3.83b6e1b9.jpg";